import { LocationPageTemplate } from "@/components/LocationPageTemplate";

export default function Pankow() {
  return (
    <LocationPageTemplate
      page={{
        location: "Pankow",
        locationSlug: "pankow",
        keyword: "Haushaltsauflösung Pankow",
        metaTitle:
          "Haushaltsauflösung Pankow | Festpreis & Termin in 48h | MIROS",
        metaDesc:
          "Professionelle Haushaltsauflösung in Berlin Pankow. Schnelle, diskrete und besenreine Haushaltsauflösung zum Festpreis. Kostenlose Besichtigung!",
        heroSub:
          "Ihre zuverlässige Haushaltsauflösung in Pankow – schnell, diskret und besenrein zum Festpreis.",
        heroImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/69909993899b886ed589bfed.jpg",
        localIntro: (
          <>
            <p>
              Pankow ist der bevölkerungsreichste Bezirk Berlins und bietet eine
              Mischung aus dichten Gründerzeitvierteln wie dem Prenzlauer Berg,
              ruhigeren Wohngegenden in Weißensee und Einfamilienhaussiedlungen
              in Französisch Buchholz oder Karow. Diese Vielfalt erfordert bei
              einer Entrümpelung Flexibilität.
            </p>
            <p>
              In den dicht bebauten Altbauquartieren rund um die Schönhauser
              Allee oder den Florakiez sind oft enge Treppenhäuser und fehlende
              Parkplätze die größte Hürde. In den nördlichen Ortsteilen geht es
              häufiger um die Räumung kompletter Häuser inklusive Keller, Garage
              und Gartenhaus.
            </p>
            <p>
              Wir kennen die unterschiedlichen Anforderungen in Pankow genau und
              passen unsere Logistik entsprechend an, um Ihre Haushaltsauflösung
              so effizient und stressfrei wie möglich zu gestalten.
            </p>
          </>
        ),
        trustText:
          "Ob in einer Altbauwohnung im Florakiez oder einem Einfamilienhaus in Karow – wir nehmen Ihnen die schwere Arbeit ab und stehen Ihnen einfühlsam zur Seite.",
        trustQuote:
          "Die Entrümpelung unserer Wohnung in Pankow lief reibungslos. Das Team war sehr freundlich und hat alles besenrein hinterlassen.",
        challengesText: (
          <>
            <p>
              In den dichter besiedelten Teilen Pankows übernehmen wir
              selbstverständlich die Beantragung und Einrichtung von
              Halteverbotszonen. So garantieren wir kurze Wege und einen zügigen
              Abtransport ohne die Nachbarschaft übermäßig zu stören.
            </p>
            <p>
              Bei großen Grundstücken im Norden des Bezirks bringen wir
              ausreichend Kapazitäten mit, um auch umfangreiche Räumungen von
              Nebengebäuden oder verwilderten Gärten schnell abzuschließen. Die
              fachgerechte Trennung und Entsorgung auf den Berliner
              Recyclinghöfen ist dabei immer inklusive.
            </p>
          </>
        ),
        reviews: [
          {
            text: "Pünktlich, schnell und ein fairer Festpreis. Sehr zu empfehlen für Entrümpelungen in Pankow.",
            author: "Kunde aus Pankow",
          },
          {
            text: "Die Räumung des Hauses meiner Eltern in Weißensee wurde sehr diskret und respektvoll durchgeführt.",
            author: "Kundin aus Weißensee",
          },
          {
            text: "Toller Service, alles wurde wie besprochen erledigt. Die Wohnung war danach wirklich besenrein.",
            author: "Kunde aus Prenzlauer Berg",
          },
        ],
        neighbors: [
          { name: "Reinickendorf", slug: "reinickendorf" },
          { name: "Mitte", slug: "berlin" },
          { name: "Oberhavel", slug: "oberhavel" },
        ],
        faqs: [
          {
            q: "Beantragen Sie die Halteverbotszone in Pankow selbst?",
            a: "Ja, wir kümmern uns um die komplette Abwicklung mit dem Bezirksamt Pankow und stellen die Schilder rechtzeitig auf.",
          },
          {
            q: "Räumen Sie auch Keller und Dachböden in Altbauten?",
            a: "Selbstverständlich. Wir räumen vom Keller bis zum Dachboden, auch in Gebäuden ohne Aufzug.",
          },
          {
            q: "Was kostet eine Haushaltsauflösung in Pankow?",
            a: "Die Kosten hängen vom Aufwand ab. Nach einer kostenlosen Besichtigung erhalten Sie von uns einen verbindlichen Festpreis.",
          },
          {
            q: "Werden verwertbare Möbel angerechnet?",
            a: "Ja, gut erhaltene Möbel oder Wertsachen können wir fair bewerten und mit den Entrümpelungskosten verrechnen.",
          },
        ],
      }}
    />
  );
}
